import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as airportActions from './../../../../actions/airportAction';
import Airports from './Airports';

const mapStateToProps = state => {
    return {
        airportState: state.airportReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListAirports: (filters) => dispatch(airportActions.getListAirports(filters)),
        deleteAirportDetail: (airport, filters) => dispatch(airportActions.deleteAirportDetail(airport, filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Airports));
